import React, { useEffect, useRef, useState } from 'react';
import Hint from '../../assets/Hint';
import s from './StandardItem.module.scss';
import productStyle from './../AttributeComponents/Product.module.scss';
import CloseSvg from '../../assets/CloseSvg';
import { useStoreDispatch, useStoreSelector } from '../..';
import { modalName } from '../../store/reducers/Settings';
import { SetActiveItem, SetModal } from '../../store/actions/Settings';
import { stringDataParameters } from '../../utils/constants';
import { useLocation } from 'react-router-dom';
import {
  getActualAttributesByName,
  getConfigInfo,
} from '../../store/selectors/selectors';
import { getActualPrice, getActualTitle } from '../AttributeComponents/Product';
import { useAttribute, useConfigurator } from '@threekit-tools/treble/dist';
import { getActualPriceById } from './../../store/selectors/selectors';
import useImage from '../../hooks/useImage';
import { NoImage } from '../../utils/helpFunctions';
import { getLocalIcon } from '../../assets/icon-props';
export function pathImage(name: any) {
  const { loading, error, image } = useImage(name);
  let result = '';
  if (!loading && image) {
    result = image;
  }
  return result;
}
export const StandardItem = React.memo(({ ...props }) => {
  const {
    item,
    currentValue,
    isAsset,
    value,
    hintPosition = 'top',
    isUrlLoaderActive,
    name,
    price,
    NotImage = '',
  }: any = props;
  const search = useLocation().search;
  const { pathname } = useLocation();
  const jeepType: '2d' | '4d' = pathname.includes('2Door') ? '2d' : '4d';
  const configInfo = useStoreSelector(getConfigInfo);
  const { img, title } = getActualInfo();
  const [attribute, setAttribute]: any = useAttribute(name);
  // const attributeInfo: any = useStoreSelector(getActualAttributesByName(name));
  const attributeInfo = useStoreSelector(getActualPriceById);

  let attributeIsActive = new URLSearchParams(search).get(name);
  const dispatch = useStoreDispatch();
  const openTutorial = ({ e, name, item }: any) => {
    dispatch(
      SetModal({ list: { [name]: true }, info: { hintPosition, e, item } })
    );
  };

  function changeItem(value: any, label: string, price: any) {
    let actualDataItem = attribute.values.find(
      (item: any) => item.label === label
    );
    let id = undefined;
    let apiImage = label ? actualDataItem.metadata._img : '';

    if (label !== 'None') {
      id = actualDataItem.metadata._id;
    }

    const localIcon = getLocalIcon(id, label, name, jeepType);
    const infoParameters = apiImage || localIcon || '';

    setAttribute(value);
    console.log(`[StandardItem.changeItem] ${name}/${label}: price=${price}, id=${id}`);
    dispatch(
      SetActiveItem({
        name,
        data: {
          activeItem: label,
          activeItemId: id,
          img: infoParameters,
          price: price,
        },
      })
    );
  }

  useEffect(() => {
    if (!attributeIsActive) {
      let label = getActualTitle(attribute);
      let priceInfo: any;
      let price = 0;
      let id = undefined;
      let actualDataItem = attribute.values.find(
        (item: any) => item.label === label
      );
      let apiImage = label ? actualDataItem.metadata._img : '';
      if (label !== 'None') {
        id = actualDataItem.metadata._id;
        priceInfo = attributeInfo[id];
        price = getActualPrice({ isAsset, item: actualDataItem, priceInfo });
      }

      const localIcon = getLocalIcon(id, label, name, jeepType);
      const infoParameters = apiImage || localIcon || '';

      dispatch(
        SetActiveItem({
          name,
          data: {
            activeItem: label,
            activeItemId: id,
            img: infoParameters,
            price,
          },
        })
      );
    }
  }, []);

  let actualValue = value;
  if (isAsset) {
    if (attributeIsActive && isUrlLoaderActive) {
      actualValue = item.metadata.option;
    }
  }

  const wrapperEl: any = useRef(null);
  const [openModal, setOpenModal]: any = useState(false);
  function getActualInfo() {
    let img: string;
    let title: string;
    const apiImage = item.metadata?._img || undefined;
    const localIcon = getLocalIcon(item.metadata?._id, item.label, name, jeepType);
    img = apiImage || localIcon || NotImage;
    title = item.label;

    return { img, title };
  }
  function closeHint() {
    setOpenModal(false);
  }

  function openHint() {
    setOpenModal(true);
  }

  const wrapperRef: any = useRef(null);
  useEffect(() => {
    const handleClickOutside =
      (wrapperRef: any, closeFunc: any) => (event: any) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeFunc();
        }
      };
    document.addEventListener(
      'mousedown',
      handleClickOutside(wrapperRef, closeHint)
    );
    return () => {
      document.removeEventListener(
        'mousedown',
        handleClickOutside(wrapperRef, closeHint)
      );
    };
  }, [wrapperRef]);

  return (
    <div
      onClick={() => changeItem(value, title, price)}
      className={`${s.card} ${currentValue === actualValue ? s.active : null}`}
    >
      {item.name !== 'None' && (
        <div
          className={s.hint}
          ref={wrapperEl}
          onClick={(e) =>
            currentValue === value &&
            openTutorial({ e, name: 'itemHint', item })
          }
        >

        </div>
      )}



      {img ? (
        <div className={s.img}>
          <img src={img} alt="product img" />
        </div>
      ) : (
        <div className={`${s.img} ${s.imgEmpty}`}>
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" strokeDasharray="3 2" />
            <line x1="8" y1="12" x2="16" y2="12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </div>
      )}
      <div className={s.title}>{title}</div>
      {item.name !== 'None' && <div className={s.price}>${price}</div>}
    </div>
  );
});
